import { render, staticRenderFns } from "./ShareText.vue?vue&type=template&id=2733bcf0"
import script from "./ShareText.vue?vue&type=script&lang=js"
export * from "./ShareText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports